import { Button, Title, Text, Stack, Paper } from "@mantine/core";
import { filledCtaButtonProps, leftAccentCardProps } from "@canucci/base-mantine/theme";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NotFoundPage({
  title,
  message,
  dark = false,
}: {
  title?: string;
  message?: string;
  dark?: boolean;
}) {
  const { t } = useTranslation("pages");
  const paperProps = dark ? leftAccentCardProps : { bg: "white", radius: "md", shadow: "md" as const };

  return (
    <Stack justify="center" align="center" h="100vh" bg={dark ? "transparent" : "gray.1"}>
      <Paper {...paperProps} p="lg">
        <Stack gap="md" ta="center">
          <Title component="h1" order={1} c={dark ? "var(--text-on-dark)" : undefined}>
            {title || t("errors.notFound.title")}
          </Title>
          <Text c={dark ? "var(--text-on-dark-muted)" : undefined}>{message || t("errors.notFound.message")}</Text>
          <Button {...(dark ? filledCtaButtonProps("primary") : {})} component={Link} to="/">
            {t("errors.notFound.goHome")}
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
}
